import { styled } from '@mui/material'

import AvatarWrapper from '../wrapper/AvatarWrapper'

export const CustomAvatar = styled(AvatarWrapper)(() => ({
  border: '1px solid white',
  width: 90,
  height: 90
}))
